'use client'

import type { MenuItem, MenuSeparator } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

import { HELP_ITEM_ID } from './help-item-id.const'

export const DEFAULT_HELP_ITEMS: (MenuItem | MenuSeparator)[] = [
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.BookOpenRegular,
    label: 'Docs',
    id: HELP_ITEM_ID.DOCS,
    size: 'xs',
  },
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.TextBulletListRegular,
    label: 'Changelog',
    id: HELP_ITEM_ID.CHANGELOG,
    size: 'xs',
  },
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.LightbulbFilamentRegular,
    label: 'Share feedback',
    id: HELP_ITEM_ID.SHARE_FEEDBACK,
    size: 'xs',
  },
  {
    type: 'item',
    active: false,
    groups: [],
    icon: Icon.ArrowEnterLeftRegular,
    label: 'Keyboard shortcuts',
    id: HELP_ITEM_ID.KEYBOARD_SHORTCUTS,
    size: 'xs',
  },
  {
    id: 'help-sep-1',
    type: 'separator',
  },
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.DSDiscordBlack,
    label: 'Community (Discord)',
    id: HELP_ITEM_ID.DISCORD,
    size: 'xs',
  },
]
